export function LoginPage({ error }: { error?: string }) {
  return (
    <div
      className="flex h-screen w-screen items-center justify-center"
    >
      <div
        className="flex w-full max-w-sm flex-col items-center gap-8 rounded-2xl p-10"
        style={{
          background: 'var(--bg-secondary)',
          border: '1px solid var(--border)',
          boxShadow: '0 8px 40px rgba(0,0,0,0.5)',
        }}
      >
        {/* Logo */}
        <div className="flex flex-col items-center gap-3">
          <div
            className="flex h-14 w-14 items-center justify-center rounded-2xl text-white text-xl font-bold"
            style={{ background: 'linear-gradient(135deg, #0dcfb8 0%, #06b6d4 100%)' }}
          >
            AI
          </div>
          <div className="text-center">
            <div className="text-lg font-bold text-text-primary">Cerbo Import</div>
            <div className="text-xs uppercase tracking-widest text-text-dimmed">v3 · ai platform</div>
          </div>
        </div>

        {error && (
          <div
            className="w-full rounded-xl px-4 py-3 text-center text-sm"
            style={{ background: 'rgba(238,93,80,0.12)', border: '1px solid rgba(238,93,80,0.3)', color: 'var(--accent-red)' }}
          >
            {error === 'domain'
              ? 'Only @cer.bo accounts are allowed.'
              : error === 'inactive'
              ? 'Your account has been deactivated.'
              : 'Sign-in failed. Please try again.'}
          </div>
        )}

        <div className="flex w-full flex-col gap-3 text-center">
          <div className="text-sm text-text-secondary">Sign in with your Cerbo Microsoft account</div>
          <a
            href="/auth/microsoft"
            className="flex w-full items-center justify-center gap-3 rounded-xl px-5 py-3 text-sm font-semibold text-white transition-opacity duration-150 hover:opacity-90"
            style={{ background: 'linear-gradient(135deg, #0dcfb8 0%, #06b6d4 100%)' }}
          >
            <MicrosoftIcon />
            Continue with Microsoft
          </a>
        </div>

        <div className="text-xs text-text-dimmed">Access restricted to @cer.bo</div>
      </div>
    </div>
  );
}

function MicrosoftIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 21 21" fill="none">
      <rect x="1" y="1" width="9" height="9" fill="#f25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
      <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
      <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
    </svg>
  );
}
